<template>
    <div>
        <div class="columns toolbar-box action-right">
            <div class="column is-2">
                <h1 class="title is-3 between-center">
                    <span>Teams</span>
                </h1>
            </div>
            <div class="column is-6-tablet is-2-desktop">
                <o-field>
                    <o-input
                        type="search"
                        v-model="filters.name"
                        placeholder="Name"
                        icon="search"
                    />
                </o-field>
            </div>
            <div class="column is-5-tablet is-4-desktop action-box">
                <div class="field is-grouped is-grouped-right">
                    <p v-if="isResetFiltersButtonVisible" class="control">
                        <a @click.prevent="resetFilters" class="button is-info"><span>Reset filters</span></a>
                    </p>
                    <p v-if="isDeleteSelectedButtonVisible" class="control">
                        <a @click.prevent="handleUserDeletion" class="button is-danger"><span>Delete selected</span></a>
                    </p>
                    <p class="control">
                        <a class="button is-info" @click.prevent="handleCreate">
                            <span class="icon"><i class="icm-new"></i></span><span>New</span>
                        </a>
                    </p>
                </div>
            </div>
        </div>
        <o-table
                class="is-responsive is-responsive-xs-desktop"

                v-if="isTableVisible"
                :data="filteredTeams"

                :bordered="table.bordered"
                :striped="table.striped"
                :narrowed="table.narrowed"
                :checkable="table.checkable"
                :mobile-cards="table.mobileCards"
                :paginated="table.paginated"
                :pagination-simple="table.paginationSimple"
                :per-page="table.perPage"
                :default-sort-direction="table.defaultSortDirection"
                :default-sort="table.defaultSort"

                :selected.sync="selected"
                :checked-rows="checkedRows"
@update:checkedRows="$event => checkedRows = $event"

                :loading="loading"
                :total="total"
        >
            <template slot-scope="props">
                <o-table-column field="name" label="Name" key="name" :sortable="true">
                    <a @click.prevent="handleUpdate(props.row)">{{ props.row.name }}</a>
                </o-table-column>

                <o-table-column field="monthly_goal" label="Monthly Goal" key="monthly_goal" :sortable="true">
                    {{ props.row.monthly_goal | currency | valueOrDefault('-') }}
                </o-table-column>

                <o-table-column field="users_count" label="Users" key="users" :sortable="true">
                    {{ usersEmailsByIds(props.row.users) }}
                </o-table-column>

                <o-table-column field="created_at" label="Created" key="created_at" :sortable="true">
                    {{ props.row.created_at | datetime }}
                </o-table-column>

                <o-table-column field="updated_at" label="Updated" key="updated_at" :sortable="true">
                    {{ props.row.updated_at | datetime }}
                </o-table-column>

                <o-table-column label="" :sortable="false">
                    <o-dropdown hoverable position="bottom-left" class="table-actions">
                        <button class="button" slot="trigger">
                            <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                        </button>
                        <o-dropdown-item has-link>
                            <a @click.prevent="handleUpdate(props.row)">Edit</a>
                        </o-dropdown-item>

                        <o-dropdown-item has-link>
                            <a @click.prevent="confirmCustomDelete(props.row)">Delete</a>
                        </o-dropdown-item>
                    </o-dropdown>
                </o-table-column>
            </template>

            <div slot="empty" class="has-text-centered">
                This table is empty!
            </div>
        </o-table>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isModalActive" has-modal-card>
            <team-modal :team-id="currentTeamId" />
        </o-modal>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import Table from './../../mixins/Table'
    import TeamModal from './Modal'

    export default {
        mixins: [Table],

        components: {
            TeamModal
        },

        computed: {
            ...mapGetters(['teams', 'usersEmailsByIds']),

            filteredTeams() {
                if (!this.filters.name) return this.teams

                return _.filter(this.teams, team => team.name.includes(this.filters.name))
            },
        },

        data() {
            return {
                filters: {
                    name: ''
                },
                currentTeamId: null,
                isModalActive: false
            }
        },

        methods: {
            ...mapActions({
                removeItem: 'removeTeam',
            }),

            handleCreate() {
                this.currentTeamId = null
                this.isModalActive = true
            },

            handleUpdate(team) {
                this.currentTeamId = team.id
                this.isModalActive = true
            },
        }
    }
</script>
